/**
 * @file success-popup.ts
 * @module app/modules/_common/components/pop-up/success-popup
 * @description Utility for displaying a success popup.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 2.1.1
 * @version 2.1.2
 */

import { showPopup } from './popup-service';
import type { PopupOptions } from './popup-service';

const showSuccessPopup = (options: PopupOptions | string = {}) =>
  showPopup('success', options);

export default showSuccessPopup;